export default __webpack_public_path__ + "13249ca2d6cda1d693d3bcbec0e152e9.svg";